function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1912(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 18.36,
    height: 3.15,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.18,
    y: 1.575
  }, "\n        Alpine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 3.15,
    width: 18.36,
    height: 14.53,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.6325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.18,
    y: 10.415
  }, "\n        Mono\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 17.67,
    width: 18.36,
    height: 33.18,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.04
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.18,
    y: 34.260000000000005
  }, "\n        Del_Norte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 50.86,
    width: 18.36,
    height: 39.21,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6228571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.18,
    y: 70.465
  }, "\n        Trinity\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 90.06,
    width: 18.36,
    height: 45.58,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.06
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.18,
    y: 112.85
  }, "\n        Sierra\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 135.65,
    width: 18.36,
    height: 46.06,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.295
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.18,
    y: 158.68
  }, "\n        Mariposa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 181.7,
    width: 18.36,
    height: 55.58,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.06
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.18,
    y: 209.48999999999998
  }, "\n        Lassen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 237.28,
    width: 18.36,
    height: 64.04,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.59
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.18,
    y: 269.3
  }, "\n        Inyo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 301.33,
    width: 18.36,
    height: 67.47,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.6719999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.18,
    y: 335.065
  }, "\n        Modoc\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 368.8,
    width: 18.36,
    height: 70.11,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.06
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.18,
    y: 403.855
  }, "\n        Plumas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 438.9,
    width: 18.36,
    height: 81.01,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.06
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.18,
    y: 479.405
  }, "\n        Sutter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 519.91,
    width: 18.36,
    height: 84.87,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.59
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.18,
    y: 562.345
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 604.78,
    width: 18.36,
    height: 95.22,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.06
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.18,
    y: 652.39
  }, "\n        Madera\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.36,
    y: 0,
    width: 37.49,
    height: 46.94,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.498
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.105000000000004,
    y: 23.47
  }, "\n        Glenn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.85,
    y: 0,
    width: 38.54,
    height: 46.94,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.423333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.12,
    y: 23.47
  }, "\n        Amador\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.4,
    y: 0,
    width: 39.62,
    height: 46.94,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9619999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.21000000000001,
    y: 23.47
  }, "\n        San_Benito\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.01,
    y: 0,
    width: 40.2,
    height: 46.94,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.05
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 154.10999999999999,
    y: 23.47
  }, "\n        Yuba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 174.22,
    y: 0,
    width: 40.42,
    height: 46.94,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.0525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 194.43,
    y: 23.47
  }, "\n        Tuolumne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 214.64,
    y: 0,
    width: 42.07,
    height: 46.94,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.674444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 235.67499999999998,
    y: 23.47
  }, "\n        El_Dorado\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256.7,
    y: 0,
    width: 42.62,
    height: 46.94,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.103333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 278.01,
    y: 23.47
  }, "\n        Colusa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.32,
    y: 0,
    width: 47.56,
    height: 46.94,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.2155555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 323.1,
    y: 23.47
  }, "\n        Calaveras\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 346.89,
    y: 0,
    width: 51.84,
    height: 46.94,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.8675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 372.81,
    y: 23.47
  }, "\n        Imperial\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 398.73,
    y: 0,
    width: 52.07,
    height: 46.94,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.823333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 424.76500000000004,
    y: 23.47
  }, "\n        Tehama\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 450.8,
    y: 0,
    width: 60.79,
    height: 46.94,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.388
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 481.195,
    y: 23.47
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 511.59,
    y: 0,
    width: 61.5,
    height: 46.94,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.735
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 542.3399999999999,
    y: 23.47
  }, "\n        Yolo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 573.09,
    y: 0,
    width: 61.81,
    height: 46.94,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.823333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 603.995,
    y: 23.47
  }, "\n        Nevada\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 634.9,
    y: 0,
    width: 65.1,
    height: 46.94,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.823333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 667.4499999999999,
    y: 23.47
  }, "\n        Merced\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.36,
    y: 46.94,
    width: 62.31,
    height: 50.54,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.423333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.515,
    y: 72.21
  }, "\n        Placer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.36,
    y: 97.48,
    width: 62.31,
    height: 54.33,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.055
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.515,
    y: 124.64500000000001
  }, "\n        Shasta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.36,
    y: 151.81,
    width: 62.31,
    height: 56.06,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.008571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.515,
    y: 179.84
  }, "\n        Ventura\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.36,
    y: 207.86,
    width: 62.31,
    height: 57.68,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.21
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.515,
    y: 236.70000000000002
  }, "\n        Siskiyou\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.36,
    y: 265.54,
    width: 62.31,
    height: 64.41,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.154
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.515,
    y: 297.745
  }, "\n        San_Luis_Obispo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.36,
    y: 329.95,
    width: 62.31,
    height: 65.51,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.923333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.515,
    y: 362.705
  }, "\n        Mendocino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.36,
    y: 395.46,
    width: 62.31,
    height: 66.33,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.5775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.515,
    y: 428.625
  }, "\n        Napa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.36,
    y: 461.8,
    width: 62.31,
    height: 74.23,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.462
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.515,
    y: 498.915
  }, "\n        Marin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.36,
    y: 536.03,
    width: 62.31,
    height: 81.02,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.923333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.515,
    y: 576.54
  }, "\n        San_Mateo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.36,
    y: 617.05,
    width: 62.31,
    height: 82.95,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.231
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.515,
    y: 658.525
  }, "\n        Santa_Cruz\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.68,
    y: 46.94,
    width: 67.79,
    height: 77.39,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.214615384615385
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.57500000000002,
    y: 85.63499999999999
  }, "\n        Santa_Barbara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.46,
    y: 46.94,
    width: 68.48,
    height: 77.39,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.56
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 182.70000000000002,
    y: 85.63499999999999
  }, "\n        Monterey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.94,
    y: 46.94,
    width: 73.78,
    height: 77.39,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.378
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 253.82999999999998,
    y: 85.63499999999999
  }, "\n        Stanislaus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 290.73,
    y: 46.94,
    width: 74.65,
    height: 77.39,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.441666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 328.055,
    y: 85.63499999999999
  }, "\n        Solano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 365.38,
    y: 46.94,
    width: 77.99,
    height: 77.39,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.449166666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 404.375,
    y: 85.63499999999999
  }, "\n        Contra_Costa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 443.37,
    y: 46.94,
    width: 79.87,
    height: 77.39,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.67375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 483.305,
    y: 85.63499999999999
  }, "\n        Humboldt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 523.24,
    y: 46.94,
    width: 82.4,
    height: 77.39,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.478
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 564.44,
    y: 85.63499999999999
  }, "\n        Butte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 605.64,
    y: 46.94,
    width: 94.36,
    height: 77.39,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.598888888888888
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 652.8199999999999,
    y: 85.63499999999999
  }, "\n        Riverside\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.68,
    y: 124.33,
    width: 94.94,
    height: 77.25,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128.15,
    y: 162.95499999999998
  }, "\n        Tulare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.68,
    y: 201.58,
    width: 94.94,
    height: 81.96,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.49
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128.15,
    y: 242.56
  }, "\n        Kern\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.68,
    y: 283.54,
    width: 94.94,
    height: 86.95,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.491666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128.15,
    y: 327.01500000000004
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.68,
    y: 370.49,
    width: 94.94,
    height: 104.6,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.63090909090909
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128.15,
    y: 422.79
  }, "\n        San_Joaquin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.68,
    y: 475.09,
    width: 94.94,
    height: 108.1,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.823333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128.15,
    y: 529.14
  }, "\n        Sonoma\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.68,
    y: 583.19,
    width: 94.94,
    height: 116.81,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.781428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128.15,
    y: 641.595
  }, "\n        San_Bernardino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.61,
    y: 124.33,
    width: 118.81,
    height: 116.84,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.684000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 235.01500000000001,
    y: 182.75
  }, "\n        Sacramento\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 294.42,
    y: 124.33,
    width: 128.03,
    height: 116.84,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.473333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 358.435,
    y: 182.75
  }, "\n        Fresno\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 422.45,
    y: 124.33,
    width: 134.41,
    height: 116.84,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.982222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 489.655,
    y: 182.75
  }, "\n        San_Diego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 556.86,
    y: 124.33,
    width: 143.14,
    height: 116.84,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.621818181818183
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 628.4300000000001,
    y: 182.75
  }, "\n        Santa_Clara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.61,
    y: 241.16,
    width: 264.01,
    height: 181.92,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 25.988571428571426
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 307.615,
    y: 332.12
  }, "\n        Alameda\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.61,
    y: 423.09,
    width: 264.01,
    height: 276.91,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.308461538461536
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 307.615,
    y: 561.545
  }, "\n        San_Francisco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 439.62,
    y: 241.16,
    width: 260.38,
    height: 458.84,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 23.670909090909092
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 569.81,
    y: 470.58
  }, "\n        Los_Angeles\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1912);
export default __webpack_public_path__ + "static/media/1912.3f380485a166bd6ecfd11029752a965d.svg";
export { ForwardRef as ReactComponent };